import { onMounted, onUnmounted, watch } from 'vue'
import { usePendingBookingCount } from '@/features/provider/api/usePendingBookingCount'
import { syncAppBadge } from '@/lib/appBadge'

/**
 * Keeps the PWA app-icon badge equal to the number of bookings awaiting provider review.
 * The badge disappears only once every pending booking is accepted or rejected.
 */
export function useAppBadgePendingBookings() {
  const { data: pendingCount } = usePendingBookingCount()

  function applyLatestCount() {
    // Skip while the query is still loading so a badge set by the service worker survives.
    if (typeof pendingCount.value === 'number') {
      void syncAppBadge(pendingCount.value)
    }
  }

  watch(pendingCount, applyLatestCount, { immediate: true })

  function onVisibilityChange() {
    if (document.visibilityState === 'visible') {
      applyLatestCount()
    }
  }

  onMounted(() => {
    document.addEventListener('visibilitychange', onVisibilityChange)
  })

  onUnmounted(() => {
    document.removeEventListener('visibilitychange', onVisibilityChange)
  })
}
